import {
  getFrontEndName,
  getSpecFrontEndName,
  getSpecOptionFrontEndName,
} from "@/utils/productName.utils";

export default {
  // TODO: 優化 cart module
  namespaced: true,
  state: {
    cart: [],
    isPointUsed: false,
    points: 0,
    /*
            目前只能限制使用一張折價卷，則不用陣列
        */
    // selectedCoupons: [],
    selectedCoupon: null,
    customizedOptions: {},
    selectedComboProduct: {},
    payment: {
      // 新增：發票相關欄位
      invoiceTypeIndex: null, // 發票類型索引（null: 未選擇, 0: 紙本發票, 1: 手機載具, 2: 統一編號, 3: 愛心碼）
      invoiceCarrier: null, // 手機載具號碼
      invoiceVatNumber: null, // 統一編號
      invoiceNpoBan: null, // 愛心碼
      invoiceNumber: null, // 保留以維持向後相容性
    },
    tableData: {},
    takeOutTableData: {},
  },
  getters: {
    tableName: (state) => {
      return state.tableData.tableName || "";
    },
    tableAreaId: (state) => {
      return state.tableData.areaId;
    },
    tableIndex: (state) => {
      return state.tableData.tableIndex;
    },
    takeOutTableName: (state) => {
      return state.takeOutTableData?.tableName || "";
    },
    takeOutTableAreaId: (state) => {
      return state.takeOutTableData?.areaId;
    },
    takeOutTableIndex: (state) => {
      return state.takeOutTableData?.tableIndex;
    },
    // 新增：發票相關 getters
    invoiceTypeIndex: (state) => {
      return state.payment.invoiceTypeIndex;
    },
    invoiceCarrier: (state) => {
      return state.payment.invoiceCarrier ?? null;
    },
    invoiceVatNumber: (state) => {
      return state.payment.invoiceVatNumber ?? null;
    },
    invoiceNpoBan: (state) => {
      return state.payment.invoiceNpoBan ?? null;
    },
    cartQuantity: (state) => {
      let quantity = 0;
      for (const orderItem of state.cart) {
        quantity += orderItem.quantity;
      }
      return quantity;
    },
    productQuantityInCart: (state) => (productId) => {
      let quantity = 0;
      const addProductCount = (product, count = 1) => {
        if (product?.id === productId) {
          quantity += Number(count) || 0;
        }
      };

      for (const orderItem of state.cart) {
        const orderQuantity = Number(orderItem.quantity) || 1;

        if (!orderItem.isCombo) {
          addProductCount(orderItem.product, orderQuantity);
          continue;
        }

        if (orderItem.fixedProducts?.length) {
          orderItem.fixedProducts.forEach((product) =>
            addProductCount(product, orderQuantity)
          );
        }

        if (orderItem.comboSubItem?.length) {
          orderItem.comboSubItem.forEach((group) => {
            const products = (group.products || []).concat(
              group.markUpProducts || []
            );
            products.forEach((product, index) => {
              addProductCount(
                product,
                (group.productSelectCount?.[index] || 0) * orderQuantity
              );
            });
          });
        }

        if (orderItem.comboSubAnyProducts?.orderProducts?.length) {
          orderItem.comboSubAnyProducts.orderProducts.forEach((product) =>
            addProductCount(product, orderQuantity)
          );
        }
      }

      return quantity;
    },
    consumptionPattern: (state) => {
      return state.payment.consumptionPattern || 0;
    },
    serviceFee: (state, getters, rootState, rootGetters) => {
      // 只有內用需要服務費
      if (getters.consumptionPattern != 0) {
        return 0;
      }
      const serviceFeeMode = rootGetters["basic/serviceFeeMode"];
      const serviceFeeRate = rootGetters["basic/serviceFeeRate"];
      // serviceFeeMode 0: 不啟用 1: 依照原價 2: 依照折扣後價格
      if (serviceFeeMode === 0) return 0;
      if (serviceFeeMode === 1) {
        // 依照原價
        return getters.cartTotalPrice * serviceFeeRate;
      }
      if (serviceFeeMode === 2) {
        // 依照折扣後價格
        return getters.paymentPrice * serviceFeeRate;
      }
      return 0;
    },
    displayServiceFee: (state, getters) => {
      return Math.round(getters.serviceFee).toFixed(0);
    },
    // 運費計算（僅外送/宅配模式）
    shippingFee: (state, getters, rootState, rootGetters) => {
      // 店家外送(3) / 零售宅配(5) 才需要運費
      if (![3, 5].includes(getters.consumptionPattern)) {
        return 0;
      }

      const freeShipping = rootGetters["basic/freeShipping"];
      const shippingFee = rootGetters["basic/shippingFee"];

      // 如果未設定免運門檻或運費，則不收運費
      if (!freeShipping || !shippingFee) {
        return 0;
      }

      // 如果購物車總金額達到免運門檻，則不收運費
      if (getters.paymentPrice >= freeShipping) {
        return 0;
      }

      // 未達免運門檻，收取運費
      return shippingFee;
    },
    // 顯示用的運費（格式化為整數字串）
    displayShippingFee: (state, getters) => {
      return Math.round(getters.shippingFee).toFixed(0);
    },
    // 積點折抵前應付總額（已扣優惠券、含服務費與運費）＝ 紅利積分折抵上限
    totalBeforePointDiscount: (state, getters) => {
      return Math.round(
        getters.paymentPrice + getters.serviceFee + getters.shippingFee
      );
    },
    displayCartTotalPrice: (state, getters) => {
      let total = getters.totalBeforePointDiscount;
      if (state.isPointUsed && state.points > 0) {
        total -= state.points;
      }
      return total < 0 ? 0 : total;
    },
    cartTotalPrice: (state, getters, rootState) => {
      let totalPrice = 0;
      for (const orderItem of state.cart) {
        if (!orderItem.isCombo) {
          // 一般餐點
          const customizedTotalPrice = orderItem.settings.reduce(
            (total, spec) => {
              return (total += spec.subSpecOptionSelectCount.reduce(
                (total, count, index) => {
                  if (
                    count === 0 ||
                    !spec.specOptions ||
                    !spec.specOptions.length
                  )
                    return total;
                  return (total += count * spec.specOptions[index].price);
                },
                0
              ));
            },
            0
          );
          const productPrice = orderItem.product.price;
          totalPrice +=
            orderItem.quantity * (productPrice + customizedTotalPrice);
        } else if (orderItem.isCombo) {
          // 套餐
          // 套餐子項
          const customizedTotalPrice = orderItem.comboSubItem
            .flatMap((group) =>
              (group?.productSelectCount || []).map((count, index) => ({
                count,
                product:
                  index > group.products.length - 1
                    ? group.markUpProducts[index - group.products.length]
                    : group.products[index],
              }))
            )
            .reduce((total, { count, product }) => {
              if (
                count === 0 ||
                !product.productSpecSettings ||
                !product.productSpecSettings.length
              )
                return total;
              return (total += product.productSpecSettings.reduce(
                (total, spec) => {
                  if (!spec.subSpecOptionSelectCount) return total;
                  return (total += spec.subSpecOptionSelectCount.reduce(
                    (total, count, index) => {
                      if (
                        count === 0 ||
                        !spec.specOptions ||
                        !spec.specOptions.length
                      )
                        return total;
                      return (total += count * spec.specOptions[index].price);
                    },
                    0
                  ));
                },
                0
              ));
            }, 0);

          // 套餐子項加價
          const markUpItemsTotalPrice = orderItem.comboSubItem
            .flatMap((group) =>
              (group?.productSelectCount || []).map((count, index) => ({
                count,
                product:
                  index > group.products.length - 1
                    ? group.markUpProducts[index - group.products.length]
                    : group.products[index],
              }))
            )
            .reduce((total, { count, product }) => {
              if (count === 0) return total;
              return (total += count * product.altAddonPrice);
            }, 0);

          // 套餐任選子項
          let comboSubAnyPrice = 0;
          if (
            orderItem.comboSubAnyProducts.orderProducts !== undefined &&
            orderItem.comboSubAnyProducts.orderProducts.length
          ) {
            orderItem.comboSubAnyProducts.orderProducts.forEach((product) => {
              if (product.productSpecSettings.length) {
                product.productSpecSettings.forEach((spec) => {
                  spec.subSpecOptionSelectCount.forEach((count, index) => {
                    if (count !== 0) {
                      comboSubAnyPrice += spec.specOptions[index].price * count;
                    }
                  });
                });
              }
            });
          }

          // 固定餐點規格加價
          let fixedProductSpecPrice = 0;
          for (const product of orderItem.fixedProducts) {
            if (product.productSpecSettings.length) {
              product.productSpecSettings.forEach((spec) => {
                spec.subSpecOptionSelectCount.forEach((count, index) => {
                  if (count !== 0) {
                    fixedProductSpecPrice +=
                      spec.specOptions[index].price * count;
                  }
                });
              });
            }
          }
          const comboPrice = orderItem.product.price;
          totalPrice +=
            orderItem.quantity *
            (comboPrice +
              customizedTotalPrice +
              markUpItemsTotalPrice +
              comboSubAnyPrice +
              fixedProductSpecPrice);
        }
      }
      if (rootState.order.orderSpecs.length) {
        for (const setting of rootState.order.orderSpecs) {
          if (
            setting.productSpec &&
            setting.productSpec.specOptions &&
            setting.productSpec.specOptions.length
          ) {
            totalPrice += setting.productSpec.specOptions.reduce(
              (total, spec, index) => {
                return (total +=
                  spec.price * setting.subSpecOptionSelectCount[index]);
              },
              0
            );
          }
        }
      }
      return totalPrice;
    },
    paymentPrice: (state, getters) => {
      let totalPrice = getters.cartTotalPrice;
      if (state.selectedCoupon) {
        totalPrice -= state.selectedCoupon.value;
      }
      return totalPrice < 0 ? 0 : totalPrice;
    },
    selectedCouponValue: (state) => {
      // let value = 0;
      // for (const coupon of state.selectedCoupon) {
      //     if (coupon.value !== null) {
      //         value += coupon.value;
      //     }
      // }
      if (state.selectedCoupon) {
        return state.selectedCoupon.value;
      }
      return 0;
    },
    displayProductSpecOptionText: () => (customizedText) => {
      if (!customizedText || customizedText.length === 0) {
        return "";
      }

      return customizedText
        .map((product, productIndex) => {
          let productText = "";

          if (product.title) {
            productText += product.title;
          }

          if (product.specOptions && product.specOptions.length > 0) {
            productText += " ";
            productText += product.specOptions
              .map((spec, specIndex) => {
                let specText = spec.title + "：";
                specText += spec.options
                  .map((option, optionIndex) => {
                    let optionText = "";
                    if (
                      typeof option === "number" &&
                      !isNaN(option) &&
                      option > 0
                    ) {
                      optionText += "+";
                    }
                    optionText += option;
                    if (
                      optionIndex < spec.options.length - 1 &&
                      typeof spec.options[optionIndex + 1] !== "number"
                    ) {
                      optionText += "、";
                    }
                    return optionText;
                  })
                  .join("");
                if (specIndex < product.specOptions.length - 1) {
                  specText += "、";
                }
                return specText;
              })
              .join("");
          }

          if (productIndex < customizedText.length - 1) {
            productText += " / ";
          }

          return productText;
        })
        .join("");
    },
    displayComboSpecOptionText: () => (customizedText) => {
      if (!customizedText || customizedText.length === 0) {
        return "";
      }

      return customizedText
        .map((product, productIndex) => {
          let productText = "";

          if (product.title) {
            productText += product.title;
            if (product.altAddonPrice) {
              productText +=
                product.altAddonPrice > 0
                  ? `+${product.altAddonPrice}`
                  : product.altAddonPrice;
            }
            if (product.count && product.count > 1) {
              productText += ` x${product.count}`;
            }
            if (product.specOptions && product.specOptions.length > 0) {
              productText += "：";
            }
          }

          if (product.specOptions && product.specOptions.length > 0) {
            productText += " ";
            productText += product.specOptions
              .map((spec, specIndex) => {
                let specText = "";
                specText += spec.options
                  .map((option, optionIndex) => {
                    let optionText = "";
                    if (
                      typeof option === "number" &&
                      !isNaN(option) &&
                      option > 0
                    ) {
                      optionText += "+";
                    }
                    optionText += option;
                    if (
                      optionIndex < spec.options.length - 1 &&
                      typeof spec.options[optionIndex + 1] !== "number"
                    ) {
                      optionText += "、";
                    }
                    return optionText;
                  })
                  .join("");
                if (specIndex < product.specOptions.length - 1) {
                  specText += "、";
                }
                return specText;
              })
              .join("");
          }

          if (productIndex < customizedText.length - 1) {
            productText += " / ";
          }

          return productText;
        })
        .join("");
    },
    customizedText: () => (product) => {
      const specOptions = [];

      // 給一般餐點使用
      const productSpecSettings = (setting) => {
        const productOption = {
          title: "",
          specOptions: [],
        };

        if (
          setting.subSpecOptionSelectCount &&
          setting.specOptions &&
          setting.specOptions.length === setting.subSpecOptionSelectCount.length
        ) {
          const specCount =
            setting.subSpecOptionSelectCount?.reduce(
              (acc, count) => acc + count,
              0
            ) || 0;
          if (specCount !== 0) {
            const specOption = {
              title: getSpecFrontEndName(setting),
              options: setting.subSpecOptionSelectCount
                .map((count, index) => {
                  if (count !== 0) {
                    const specName = getSpecOptionFrontEndName(
                      setting.specOptions[index].name
                    );
                    const specPrice = setting.specOptions[index].price;
                    if (specPrice && specPrice > 0)
                      return `${specName} +${specPrice}${
                        count > 1 ? ` x${count}` : ""
                      }`;
                    else if (specPrice && specPrice < 0)
                      return `${specName} ${specPrice}`;
                    return specName;
                  }
                  return null;
                })
                .filter(Boolean), // 過濾掉 null 值
            };
            productOption.specOptions.push(specOption);
          }
        }

        return productOption;
      };

      // 給套餐使用
      const comboSpecSettings = (comboSub, comSubCount) => {
        const productOption = {
          title: getFrontEndName(comboSub.name),
          specOptions: [],
          altAddonPrice: comboSub.altAddonPrice || 0,
        };

        if (comSubCount && comSubCount > 1) {
          productOption.count = comSubCount;
        }

        if (
          comboSub.productSpecSettings &&
          comboSub.productSpecSettings.length
        ) {
          comboSub.productSpecSettings.forEach((spec) => {
            const specCount =
              spec.subSpecOptionSelectCount?.reduce(
                (acc, count) => acc + count,
                0
              ) || 0;
            if (specCount !== 0) {
              const specOption = {
                title: getSpecFrontEndName(spec),
                options: spec.subSpecOptionSelectCount
                  .map((count, index) => {
                    if (count !== 0) {
                      const specName = getSpecOptionFrontEndName(
                        spec.specOptions[index].name
                      );
                      const specPrice = spec.specOptions[index].price;
                      if (specPrice && specPrice > 0)
                        return `${specName} +${specPrice}${
                          count > 1 ? ` x${count}` : ""
                        }`;
                      else if (specPrice && specPrice < 0)
                        return `${specName} ${specPrice}`;
                      return specName;
                    }
                    return null;
                  })
                  .filter(Boolean), // 過濾掉 null 值
              };
              productOption.specOptions.push(specOption);
            }
          });
        }

        return productOption;
      };

      const processProducts = (products, productCounts) => {
        products.forEach((product, index) => {
          if (productCounts[index] !== 0) {
            specOptions.push(comboSpecSettings(product, productCounts[index]));
          }
        });
      };

      if (product.isCombo) {
        // 套餐 - 固定餐點
        if (product.fixedProducts?.length) {
          product.fixedProducts.forEach((product) => {
            specOptions.push(comboSpecSettings(product));
          });
        }

        // 套餐子項任選
        if (product.comboSubItem?.length) {
          product.comboSubItem.forEach((products) => {
            processProducts(
              products.products.concat(products.markUpProducts || []),
              products.productSelectCount
            );
          });
        }

        // 任選子項
        if (product.comboSubAnyProducts?.orderProducts?.length) {
          processProducts(
            product.comboSubAnyProducts.orderProducts,
            product.comboSubAnyProducts.orderProducts.map(() => 1)
          );
        }
      } else {
        // 一般餐點
        if (product.settings?.length) {
          product.settings.forEach((setting) => {
            const productOption = productSpecSettings(setting);
            if (productOption.specOptions.length) {
              specOptions.push(productOption);
            }
          });
        }
      }

      return specOptions;
    },
    productUnitPrice: () => (product) => {
      // 給確認餐點使用 總價 = 商品單價 + 客製化加價
      // 一般餐點
      if (!product.isCombo) {
        const customizedTotalPrice = product.settings.reduce((total, spec) => {
          return (total += spec.subSpecOptionSelectCount.reduce(
            (total, count, index) => {
              if (count === 0 || !spec.specOptions || !spec.specOptions.length)
                return total;
              return (total += count * spec.specOptions[index].price);
            },
            0
          ));
        }, 0);
        const productPrice = product.product.price;
        return productPrice + customizedTotalPrice;
      } else {
        // 套餐
        // 套餐子項
        const customizedTotalPrice = product.comboSubItem
          .flatMap((group) =>
            (group?.productSelectCount || []).map((count, index) => ({
              count,
              product:
                index > group.products.length - 1
                  ? group.markUpProducts[index - group.products.length]
                  : group.products[index],
            }))
          )
          .reduce((total, { count, product }) => {
            if (
              count === 0 ||
              !product.productSpecSettings ||
              !product.productSpecSettings.length
            )
              return total;
            return (total += product.productSpecSettings.reduce(
              (total, spec) => {
                if (!spec.subSpecOptionSelectCount) return total;
                return (total += spec.subSpecOptionSelectCount.reduce(
                  (total, count, index) => {
                    if (
                      count === 0 ||
                      !spec.specOptions ||
                      !spec.specOptions.length
                    )
                      return total;
                    return (total += count * spec.specOptions[index].price);
                  },
                  0
                ));
              },
              0
            ));
          }, 0);

        // 套餐子項加價
        const markUpItemsTotalPrice = product.comboSubItem
          .flatMap((group) =>
            (group?.productSelectCount || []).map((count, index) => ({
              count,
              product:
                index > group.products.length - 1
                  ? group.markUpProducts[index - group.products.length]
                  : group.products[index],
            }))
          )
          .reduce((total, { count, product }) => {
            if (count === 0) return total;
            return (total += count * product.altAddonPrice);
          }, 0);

        // 套餐任選子項
        let comboSubAnyPrice = 0;
        if (
          product.comboSubAnyProducts.orderProducts !== undefined &&
          product.comboSubAnyProducts.orderProducts.length
        ) {
          product.comboSubAnyProducts.orderProducts.forEach((product) => {
            if (product.productSpecSettings.length) {
              product.productSpecSettings.forEach((spec) => {
                spec.subSpecOptionSelectCount.forEach((count, index) => {
                  if (count !== 0) {
                    comboSubAnyPrice += spec.specOptions[index].price * count;
                  }
                });
              });
            }
          });
        }

        // 固定餐點規格加價
        let fixedProductSpecPrice = 0;
        console.log(product);
        if (product.fixedProducts.length) {
          for (const fixedProduct of product.fixedProducts) {
            if (fixedProduct.productSpecSettings.length) {
              fixedProduct.productSpecSettings.forEach((spec) => {
                spec.subSpecOptionSelectCount.forEach((count, index) => {
                  if (count !== 0) {
                    fixedProductSpecPrice +=
                      spec.specOptions[index].price * count;
                  }
                });
              });
            }
          }
        }
        const comboPrice = product.product.price;
        return (
          comboPrice +
          markUpItemsTotalPrice +
          customizedTotalPrice +
          comboSubAnyPrice +
          fixedProductSpecPrice
        );
      }
    },
    productTotalPrice: (state, getters) => (product) => {
      // 給確認餐點使用 總價 = 商品單價 + 客製化加價 * 數量
      const productUnitPrice = getters.productUnitPrice(product);
      return productUnitPrice * product.quantity;
    },
  },
  mutations: {
    addToCart(state, orderItem) {
      state.cart.push(orderItem);
    },
    setCart(state, cart) {
      state.cart = cart;
    },
    setIsPointUsed(state, isPointUsed) {
      state.isPointUsed = isPointUsed;
    },
    setPoints(state, points) {
      const numericPoints = Number(points);
      state.points = Number.isFinite(numericPoints)
        ? Math.max(0, Math.floor(numericPoints))
        : 0;
    },
    setSelectedCoupon(state, selectedCoupon) {
      state.selectedCoupon = selectedCoupon;
    },
    setCustomizedOptions(state, customizedOptions) {
      state.customizedOptions = customizedOptions;
    },
    setSelectedComboProduct(state, selectedComboProduct) {
      state.selectedComboProduct = selectedComboProduct;
    },
    setPayment(state, payment) {
      state.payment = payment;
    },
    setTableData(state, tableData) {
      state.tableData = tableData;
    },
    setTakeOutTableData(state, tableData) {
      state.takeOutTableData = tableData;
    },
    // 新增：設定發票資料
    setInvoiceData(state, payload) {
      state.payment = {
        ...state.payment,
        invoiceTypeIndex:
          payload.invoiceTypeIndex ?? state.payment.invoiceTypeIndex,
        invoiceCarrier: payload.invoiceCarrier ?? null,
        invoiceVatNumber: payload.invoiceVatNumber ?? null,
        invoiceNpoBan: payload.invoiceNpoBan ?? null,
      };
    },
  },
  actions: {
    // 將 orderItem 加入 state.cart 並觸發 setCart
    addToCart({ commit }, orderItem) {
      commit("addToCart", orderItem);
    },
  },
};
